
export default {
  props: {
    link: {
      type: Object,
      default: () => {
        return { label: '' };
      },
    },
  },
  methods: {
    goToConversation() {
      this.$emit('goToConversation', this.link.conversationId);
    },
  },
};
